import type { SVGProps } from 'react'
const SvgSyMastercard = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12 6.7c1.6 1.2 2.6 3.2 2.6 5.3s-1 4.1-2.6 5.3c-1.6-1.2-2.6-3.2-2.6-5.3s1-4.1 2.6-5.3" />
		<path d="M11.1 6.1C9.4 7.5 8.4 9.7 8.4 12s1.1 4.5 2.7 5.9q-1.5.9-3.3.9C4 18.8 1 15.8 1 12s3-6.8 6.8-6.8 2.3.3 3.3.9m1.8 11.8c1.7-1.4 2.7-3.6 2.7-5.9s-1.1-4.5-2.7-5.9q1.5-.9 3.3-.9c3.8 0 6.8 3 6.8 6.8s-3 6.8-6.8 6.8-2.3-.3-3.3-.9" />
	</svg>
)
export default SvgSyMastercard
